export const COLORS = {
  black: '#000000',
  background: '#FFFFFF',
  blueGray: '#78909C',
  blueGraySecondary: '#607D8B',
  darkBlueGray: '#455A64',
  darkGray: '#212121',
  border: '#CFD8DC',
  lightGray: '#FAFAFA',
  lightGraySecondary: '#D6D6D6',
  alabaster: '#F1F1F1',
  gray: '#C4C4C4',
  yellow: '#FFCE44',
  teal: '#26A69A',
  monteCarlo: '#80CBC4',
  red: '#E35141',
  lightTeal: '#E0F2F1',
  lightTealBackground: 'rgba(224, 242, 241, 0.3)',
  white: '#ffffff',
  cornFlower: '#6998F1',
  lightGreen: '#8BC34A',
  divider: '#ECEFF1',
  warning: '#FCEDCF',
  deepBlue: '#001F35',
  green: '#4CAF50',
  amber: '#FFC107',
  foam: 'rgba(224, 242, 241, 0.5)',
  warningBackground: 'rgba(227, 81, 65, 0.08)',
  emerald: '#00695C',
  darkBlue: '#0D2C59',
  oxfordBlue: '#0D2B59',
  indigoDye: '#123E6A',

  sprouta: '#C5E0B4',
  champagne: '#FAE6D6',
  linkWater: '#DBE3F2',
};

export default () => {
  return {
    colors: {
      ...COLORS,
    },
    primary: {
      main: '#000000',
    },
    secondary: {
      main: '#78909C',
    },
  };
};



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/palette.js